(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["linova-wide-hero"] && !Shopify.designMode) return;
  try {
    
  class LinovaHeroSlider extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      const slides = [...this.querySelectorAll('[data-hero-slide]')];
      const dots = [...this.querySelectorAll('[data-hero-dot]')];
      const previous = this.querySelector('[data-hero-prev]');
      const next = this.querySelector('[data-hero-next]');
      let current = 0;
      let timer;

      if (slides.length < 2) return;

      this.dataset.ready = 'true';

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === current));
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === current));
      };

      const restart = () => {
        if (this.dataset.autoplay !== 'true') return;
        window.clearInterval(timer);
        timer = window.setInterval(() => show(current + 1), 5500);
      };

      previous?.addEventListener('click', () => {
        show(current - 1);
        restart();
      });

      next?.addEventListener('click', () => {
        show(current + 1);
        restart();
      });

      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => {
          show(dotIndex);
          restart();
        });
      });

      restart();
    }
  }

  if (!customElements.get('linova-hero-slider')) {
    customElements.define('linova-hero-slider', LinovaHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      if (url.hash) {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      }

      const activeCategory = document.querySelector('.linova-collection-sidebar__link.is-active');
      const categoryNavigation = activeCategory?.closest('.linova-collection-sidebar__nav');
      if (categoryNavigation && categoryNavigation.scrollWidth > categoryNavigation.clientWidth) {
        categoryNavigation.scrollLeft =
          activeCategory.offsetLeft - (categoryNavigation.clientWidth - activeCategory.offsetWidth) / 2;
      }
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
